export default __webpack_public_path__ + "static/eco-product-2-530de86b7c59e3c994baf938bf32a8b7.svg";